// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"476":"f11ffc7a","888":"00b842a8"}[chunkId] + ".css";
};